import { Plus, Trash2 } from 'lucide-react'
import { Select } from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { CurrencyInput } from '@/components/ui/currency-input'
import { formatBRL } from '@/lib/utils'

/**
 * Tabela editável de serviços de um aditivo.
 * value: [{ servicoID, quantidade, valorUnitario, fatura }]
 * O valorTotal é calculado (quantidade × valorUnitario).
 */
export default function ServicoEditor({ value = [], onChange, servicos = [] }) {
  function update(idx, patch) {
    const next = value.map((row, i) => (i === idx ? { ...row, ...patch } : row))
    onChange(next)
  }
  function addRow() {
    onChange([...value, { servicoID: '', quantidade: 1, valorUnitario: '', fatura: 1 }])
  }
  function removeRow(idx) {
    onChange(value.filter((_, i) => i !== idx))
  }

  const total = value.reduce((s, r) => s + Number(r.quantidade || 0) * Number(r.valorUnitario || 0), 0)

  return (
    <div className="space-y-2">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-muted-foreground">
            <tr>
              <th className="font-medium py-1.5 pr-2">Serviço</th>
              <th className="font-medium py-1.5 px-2 w-24">Qtd.</th>
              <th className="font-medium py-1.5 px-2 w-36">Vlr. unitário</th>
              <th className="font-medium py-1.5 px-2 w-32 text-right">Vlr. total</th>
              <th className="font-medium py-1.5 px-2 w-20 text-center">Fatura</th>
              <th className="w-10"></th>
            </tr>
          </thead>
          <tbody>
            {value.map((row, idx) => (
              <tr key={idx} className="border-t border-border/60">
                <td className="py-1.5 pr-2">
                  <Select value={row.servicoID} onChange={(e) => update(idx, { servicoID: e.target.value })} className="h-9">
                    <option value="">Selecione...</option>
                    {servicos.map((s) => (
                      <option key={s.servicoID} value={s.servicoID}>{s.nome}</option>
                    ))}
                  </Select>
                </td>
                <td className="py-1.5 px-2">
                  <Input type="number" min="0" value={row.quantidade} onChange={(e) => update(idx, { quantidade: e.target.value })} className="h-9" />
                </td>
                <td className="py-1.5 px-2">
                  <CurrencyInput value={row.valorUnitario} onChange={(v) => update(idx, { valorUnitario: v })} className="h-9" />
                </td>
                <td className="py-1.5 px-2 text-right tabular-nums">
                  {formatBRL(Number(row.quantidade || 0) * Number(row.valorUnitario || 0))}
                </td>
                <td className="py-1.5 px-2 text-center">
                  <input
                    type="checkbox"
                    checked={!!Number(row.fatura)}
                    onChange={(e) => update(idx, { fatura: e.target.checked ? 1 : 0 })}
                    className="h-4 w-4 accent-[var(--primary)]"
                  />
                </td>
                <td className="py-1.5 text-center">
                  <button onClick={() => removeRow(idx)} title="Remover" className="p-1 rounded hover:bg-destructive/10 text-muted-foreground hover:text-destructive">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
            {value.length === 0 && (
              <tr><td colSpan={6} className="py-3 text-center text-muted-foreground">Nenhum serviço.</td></tr>
            )}
          </tbody>
          {value.length > 0 && (
            <tfoot>
              <tr className="border-t border-border">
                <td colSpan={3} className="py-2 text-right font-medium">Total</td>
                <td className="py-2 px-2 text-right font-semibold tabular-nums">{formatBRL(total)}</td>
                <td colSpan={2}></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      <Button type="button" variant="outline" size="sm" onClick={addRow}>
        <Plus className="h-4 w-4" /> Adicionar serviço
      </Button>
    </div>
  )
}
